export default "__VITE_ASSET__DU5hTarE__"